import { inject } from '@angular/core';
import { CanMatchFn, Route, Router, UrlSegment, UrlTree } from '@angular/router';
import { Observable, map } from 'rxjs';
import { FeatureFlagKey, FeatureToggleService } from '../services/feature/feature-toggle.service';

/** canMatch guard that gates routes behind feature-flag checks. Run after authGuard. */
export const featureToggleGuard: CanMatchFn = (
  route: Route,
  _: UrlSegment[],
): Observable<boolean | UrlTree> => {
  const featureToggleService = inject(FeatureToggleService);
  const router = inject(Router);
  const featureFlagKey = route.data?.['featureFlagKey'] as FeatureFlagKey | undefined;

  if (!featureFlagKey) {
    throw new Error('featureToggleGuard requires a featureFlag key defined in route data.');
  }
  return featureToggleService
    .get(featureFlagKey)
    .pipe(map(featureFlag => (featureFlag ? true : router.createUrlTree(['not-found']))));
};
